import type { Undefinable } from "@iot-platform/core";
import * as z from "zod";

export const UserDtoSchema = z
    .object({
        id: z.int().positive(),
        email: z.string().trim(),
    })
    .readonly();

export type UserDto = z.output<typeof UserDtoSchema>;

export const UsersDtoSchema = z.array(UserDtoSchema).readonly();
export type UsersDto = z.output<typeof UsersDtoSchema>;

interface UserCreateObjectBody {
    email: UserDto["email"];
    password: Undefinable<string>;
    field_tech?: boolean;
}

export interface UserCreateBody {
    object: UserCreateObjectBody;
}

interface UserEditObjectBody {
    id: UserDto["id"];
    email: UserDto["email"];
    password: Undefinable<string>;
    field_tech: boolean;
}

export interface UserEditBody {
    object: UserEditObjectBody;
}

export interface UserCreateToSpatialLevelBody {
    user: {
        email: UserDto["email"];
        username: Undefinable<string>;
        spatial_level_ids: number[];
        field_tech?: boolean;
    };
}
